import FitScoreSvg from '../../../assets/fit-score.svg?react';
import { IconProps } from '../../types/IconProps';

export function FitScore({ size = 20, ...props }: IconProps) {
  return <FitScoreSvg data-testid="fit-score-icon" width={size} height={size} {...props} />;
}

export default FitScore;
